// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container__D49Zy{width:100%;min-height:36px}`, "",{"version":3,"sources":["webpack://./src/components/debts-table/debts-table/components/cell-data/CellData.module.scss"],"names":[],"mappings":"AAAA,kBACC,UAAA,CACA,eAAA","sourcesContent":[".container {\n\twidth: 100%;\n\tmin-height: 36px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container__D49Zy`
};
export default ___CSS_LOADER_EXPORT___;
